module.exports = __webpack_public_path__ + "img/wheel.dcc22bd1.png";